import { Box, Spinner as ChakraSpinner, SpinnerProps } from '@chakra-ui/react';

const Spinner: React.FC<SpinnerProps> = ({ ...props }) => {
  return (
    <Box>
      <ChakraSpinner
        borderWidth="4px"
        animationDuration="slowest"
        color="primary"
        css={{
          '--spinner-track-color': 'var(--chakra-colors-secondary, #17181d)',
        }}
        size="xl"
        {...props}
      />
    </Box>
  );
};

export default Spinner;
